import { Controller } from "@hotwired/stimulus";

export default class FileUploadController extends Controller {
  static targets = ["noFiles", "filesAdded", "filesAddedText"];

  handleChange(ev) {
    const files = ev.target.files;

    if (files.length > 0) {
      this.showFilesAdded(files.length);
    } else {
      this.setNoFiles();
    }
  }

  showFilesAdded(count) {
    this.noFilesTarget.classList.add("hidden");
    this.filesAddedTarget.classList.remove("hidden");

    if (count > 1) {
      this.filesAddedTextTarget.innerHTML = `${count} novos arquivos...`;
    } else {
      this.filesAddedTextTarget.innerHTML = "1 novo arquivo...";
    }
  }

  setNoFiles() {
    this.noFilesTarget.classList.remove("hidden");
    this.filesAddedTarget.classList.add("hidden");
  }
}
